export * from './partner-master.service';
import { PartnerMasterService } from './partner-master.service';

export const APIS = [PartnerMasterService];
